<div class="alert-box alert-box--{{ type }}">
  <div>
    <p class="alert-box__title">{{ config.title }}</p>
    <p class="alert-box__message">{{ config.message }}</p>
  </div>

  <button
    class="alert-box__btn qs-btn qs-btn--text-only qs-btn--icon qs-btn--icon-close"
    title="close"
    (click)="close()">
  </button>
</div>
